



























































































































































































































































































































































import { Component } from "vue-property-decorator";
import { CardVueGB } from "@/extensions/contract/CardVueGB";
import OperationsList from "@/components/history/OperationsList.vue";
import ContractDetails from "@/components/contracts/ContractDetails.vue";
import CardBlockModal from "@/components/cardOperations/CardBlockModal.vue";
import CardPinModal from "@/components/cardOperations/CardPinModal.vue";
import CardLimitsModal from "@/components/cardOperations/CardLimitsModal.vue";
import CashBackModal from "@/components/cardOperations/CashBackModal.vue";
import ChooseCashBack from "@/components/cardOperations/ChooseCashBack.vue";
import SpendCashBack from "@/components/cardOperations/SpendCashBack.vue";
import Requisites from "@/components/contracts/Requisites.vue";

@Component({
  components: {
    ContractDetails,
    CardBlockModal,
    OperationsList,
    CardLimitsModal,
    CardPinModal,
    CashBackModal,
    ChooseCashBack,
    SpendCashBack,
    Requisites
  }
})
export default class Card extends CardVueGB {
}
